import { BlurEvent, ChangeEvent, Checkbox, FocusEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutMobileCommExAppControlSendLoad } from "./autogen/AutogenLayoutMobileCommExAppControlSendLoad";
import { MobileCommFieldValidator } from "./MobileCommFieldValidator";
import { MobileCommExAppControlHelper } from "./MobileCommExAppControlBase";

/**
 * Form for managing mobile communication configurations and field layouts.
 * Handles validation of field index values against available form fields.
 */
export class MobileCommExAppControlSendLoad extends AutogenLayoutMobileCommExAppControlSendLoad {

    private static readonly FIELD_TEXTBOX_IDS = [
        "textboxFormNumber",
        "textboxLocationCode",
        "textboxStopNumber",
        "textboxPayrollDate",
        "textboxDriverID",
        "textboxSSN",
        "textboxPayeePIN",
        "textboxFieldValidateOnBlur"
    ];

    /**
     * Validates all field index textboxes to ensure values are within valid range.
     * @returns true if all validations pass, false otherwise
     */
    public validateAllFieldIndices(): boolean {
        return MobileCommFieldValidator.validateAllFieldIndices(
            this,
            MobileCommExAppControlSendLoad.FIELD_TEXTBOX_IDS,
            () => MobileCommFieldValidator.getMaxRowIndex(this.owner)
        );
    }

    /**
     * Event handler for textbox blur events.
     * Validates the field index value and displays inline warning if invalid.
     * @param event - the blur event
     */
    textboxFieldValidateOnBlur(event: BlurEvent): void {
        const textbox = event.target as Textbox;
        if (!event.changedWhileFocused) {
            return;
        }

        MobileCommFieldValidator.validateFieldOnBlur(
            textbox,
            this.owner.textboxToCheckboxMap.get(textbox.id),
            this.owner.findTextboxGroup(textbox.id),
            () => MobileCommFieldValidator.getMaxRowIndex(this.owner)
        );
    }

    /**
     * Event handler for component focus events.
     * Highlights the corresponding row in the form builder when a field textbox receives focus.
     * @param event - the focus event
     */
    componentOnFocus(event: FocusEvent): void {
        this.highlightFormField(event);
    }

    /**
     * Event handler for textbox change events.
     * Highlights the corresponding row in the form builder when a field textbox changes.
     * @param event - the change event
     */
    textboxOnChange(event: ChangeEvent): void {
        this.highlightFormField(event);
    }

    private highlightFormField(event: FocusEvent | ChangeEvent): void {
        MobileCommExAppControlHelper.componentOnFocus(event, this, MobileCommExAppControlSendLoad.FIELD_TEXTBOX_IDS);
    }
}
